import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import so from "./locales/so.json";
import fr from "./locales/fr.json";

// English-first on purpose: the OS/browser locale of a Somali-Canadian user is
// almost always en-CA regardless of which language they'd actually prefer, so
// guessing from navigator.language would be wrong more often than not. Detect
// order is localStorage (an explicit prior choice) only, falling back to the
// `fallbackLng` below — never the browser language.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      so: { translation: so },
      fr: { translation: fr },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "so", "fr"],
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "sanduuq_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    // No `react.transKeepBasicHtmlNodesFor` override: our <bold> tags are
    // mapped explicitly via Trans `components`, which needs no config, and
    // overriding the list would silently drop default <br>/<strong> handling.
  });

export default i18n;
